<template>
  <div class="actor_message_complete">
    <section class="text_left">
      <p class="actor_message_text">
        {{ actor.name }}先生へ鑑定内容を送信しました。<br>
        鑑定結果BOXに先生からの返信が届きますのでお待ち下さい。
      </p>
      <p class="actor_message_text">
        <a :href="`mailto:${attachImageMail}?body=${mailBody}&amp;subject=${mailSubject}`" class="btn arrow">画像を送信する</a>
        ※上記ボタンを選択されますと、新規メール画面が立ち上がり、画像を添付して送信頂けます。
        画像を送信する必要のない場合は、このままページ下部に御座いますメニューから番組トップページにお戻りください。
      </p>
      <p class="text_center"><router-link :to="{ name: 'Top' }" class="arrow link_main--text">トップページへ戻る</router-link></p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ActorMessageCompleteBySetting',
  props: {
    actor: Object
  },
  data () {
    return {
      mailSubject: '空メール画像添付',
      mailBody: '画像を1枚のみ添付して送信して下さい。'
    }
  },
  computed: {
    attachImageMail () {
      const postMessage = this.$store.getters.postMessage || {}
      return postMessage.attach_image_mail || ''
    }
  }
}
</script>
